import React, { useEffect } from "react";
import routeVariants from "../../assets/animates/routeVariants";
import NavbarTop from "../global/NavbarTop";
import { motion } from "framer-motion";
import CustomerStoriesCompanies from "./CustomerStoriesCompanies";
import CustomerStoriesFooter from "./CustomerStoriesFooter";
import Footer from "../global/Footer";
import NavbarBottom from "../global/NavbarBottom";
import ic_location from "../../assets/images/pictures/icon/ic_location_30px.svg";
import ic_person from "../../assets/images/pictures/icon/ic_2_person_30px.svg";
import ic_circle_checked from "../../assets/images/pictures/icon/ic_circle_checked_30px.svg";
import ic_big_person_circle from "../../assets/images/pictures/icon/ic_2_person_big_circle_64px.svg";
import { useTranslation } from "react-i18next";
import vaiku from "../../assets/images/logos/customer/vaiku_2.png";

const CustomerStoriesVaiku = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = "Vaiku linija | GoPaperless";
  });

  return (
    <>
      <NavbarTop />
      <motion.div
        variants={routeVariants}
        initial="initial"
        animate="final"
        id="content"
        className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 no-transform"
      >
        <div className="container-fluid bg-color" style={{ height: "400px" }}>
          <div className="row text-center">
            <div className="col-md-12 intro  text-center">
              <img
                width="64"
                height="64"
                src={ic_big_person_circle}
                alt=""
                decoding="async"
                loading="lazy"
                data-no-retina=""
              />
              <h1 className="why-head mb-25" data-sr="no reset">
                {t("customer.title")}
              </h1>
              <div className="text-center text-subhead" data-sr="no reset">
                <p>{t("customer.note1")}</p>
              </div>
            </div>
          </div>
        </div>
        <div id="eids">
          <div className="container mt-md-m50">
            <div className="row">
              <div className="col-sm-10 col-sm-offset-1">
                <div className="panel">
                  <div className="panel-body box">
                    <div className="col-md-4">
                      <div className="ic-box text-center">
                        <img
                          width="304"
                          src={vaiku}
                          className="img-responsive"
                          alt=""
                          decoding="async"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <div className="col-md-8 pt-20">
                      <p>
                        <a
                          href="https://www.vaikulinija.lt/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Vaikų linija / Child Line
                        </a>
                        {t("customer.vaiku.note1")}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="panel">
                  <div className="panel-body box">
                    <div className="col-md-4">
                      <div className="flex column-wrapper gap-15 pt-10">
                        <div className="flex gap-15">
                          <div>
                            <img src={ic_location} alt="" />
                          </div>
                          <div>
                            <p className="font-weight-bold mx-auto">
                              {t("customer.vaiku.note2")}
                            </p>
                            <p className="font-14">
                              {t("customer.vaiku.note3")}
                            </p>
                          </div>
                        </div>
                        <div className="flex gap-15">
                          <div>
                            <img src={ic_person} alt="" />
                          </div>
                          <div>
                            <p className="font-weight-bold mx-auto">
                              {t("customer.vaiku.note4")}
                            </p>
                            <p className="font-14">
                              {t("customer.vaiku.note5")}
                            </p>
                          </div>
                        </div>
                        <div className="flex gap-15">
                          <div>
                            <img src={ic_circle_checked} alt="" />
                          </div>
                          <div>
                            <p className="font-weight-bold mx-auto">
                              {t("customer.vaiku.note6")}
                            </p>
                            <p className="font-14 ">
                              {t("customer.vaiku.note7")}
                            </p>
                            <p className="font-14 ">
                              {t("customer.vaiku.note8")}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <p>
                        <em>{t("customer.vaiku.note9")}</em>
                      </p>
                      <p>{t("customer.vaiku.note10")}</p>
                      <h2>{t("customer.vaiku.note11")}</h2>
                      <p>{t("customer.vaiku.note12")}</p>
                      <p>{t("customer.vaiku.note13")}</p>
                      <h2>{t("customer.vaiku.note14")}</h2>
                      <p>{t("customer.vaiku.note15")}</p>
                      <p>{t("customer.vaiku.note16")}</p>

                      <h2>{t("customer.vaiku.note17")}</h2>
                      <p>{t("customer.vaiku.note18")}</p>
                      <p>{t("customer.vaiku.note19")}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <CustomerStoriesCompanies currentPage="vaiku" />
        <div className="container security-footer">
          <div className="row">
            <div className="col-sm-8 col-sm-offset-2 text-center mb-60">
              <h1>{t("customer.note17")}</h1>
              <p>{t("customer.note18")}</p>
              <a
                href="/case-studies"
                className="btn-primary"
                target="_blank"
                rel="noreferrer"
              >
                {t("customer.note19")}
              </a>
            </div>
          </div>
        </div>
        <CustomerStoriesFooter />
        <Footer />
        <NavbarBottom />
      </motion.div>
    </>
  );
};

export default CustomerStoriesVaiku;
